import { useVisualComponentsContext } from '../../contexts/visualComponents';
import { useQueryStateContext } from '../../contexts';
import { useDuplicateCriteria } from '../../hooks/criteria';

export const DuplicateButton = () => {
  const { DuplicateCriteriaButton } = useVisualComponentsContext();
  const { isReadOnly = false } = useQueryStateContext();
  const duplicateCriteria = useDuplicateCriteria();

  if (isReadOnly) return null;

  return (
    <DuplicateCriteriaButton
      isDisabled={isReadOnly}
      onClick={() => {
        duplicateCriteria();
      }}
    />
  );
};
